document.addEventListener("DOMContentLoaded", function () {
  // Get all elements with the class 'nav-menu-item-container' that contain a dropdown
  var dropdowns = document.querySelectorAll(".nav-menu-item-container");

  // dropdowns = [];
  dropdowns.forEach(function (dropdown) {
    // var dropdownContent = dropdown.querySelector(".header-dropdown-show");
    var dropdownContent = dropdown.querySelector(".dropdown-menu-container");
    // var dropdownIcon = dropdown.querySelector("#header-dropdown");
    var dropdownIcon = dropdown.querySelector(".header-dropdown-icon");

    dropdown.addEventListener("mouseenter", function () {
      // Show the primary dropdown content
      if (dropdownContent) {
        dropdownContent.style.display = "flex";
        dropdownContent.style.opacity = "1";
        // dropdownContent.style.transition = "opacity 0.3s ease";
      }

      // Rotate the dropdown icon
      // if (dropdownIcon) {
      //     dropdownIcon.style.transform = 'rotate(180deg)';
      //     dropdownIcon.style.transition = 'transform 0.3s ease';
      // }
    });

    dropdown.addEventListener("mouseleave", function () {
      // Hide the primary dropdown content only if the mouse is not over the dropdown
      setTimeout(function () {
        if (!dropdown.matches(":hover") && !dropdownContent.matches(":hover")) {
          if (dropdownContent) {
            dropdownContent.style.opacity = "0";
            dropdownContent.style.transition = "opacity 0.3s ease";
            setTimeout(function () {
              dropdownContent.style.display = "none";
            }, 300);
          }

          // Rotate the dropdown icon back to the original position
          if (dropdownIcon) {
            // dropdownIcon.style.transform = "rotate(0deg)";
            // dropdownIcon.style.transition = "transform 0.3s ease";
          }
        }
      }, 100);
    });

    if (dropdownContent) {
      dropdownContent.addEventListener("mouseenter", function () {
        // Keep the dropdown open when hovering over the dropdown content
        dropdownContent.style.opacity = "1";
        dropdownContent.style.display = "flex";
      });

      dropdownContent.addEventListener("mouseleave", function () {
        // Hide the dropdown when leaving the dropdown content
        setTimeout(function () {
          if (
            !dropdown.matches(":hover") &&
            !dropdownContent.matches(":hover")
          ) {
            dropdownContent.style.opacity = "0";
            dropdownContent.style.transition = "opacity 0.3s ease";
            setTimeout(function () {
              dropdownContent.style.display = "none";
            }, 300);

            // Rotate the dropdown icon back to the original position
            if (dropdownIcon) {
              dropdownIcon.style.transform = "rotate(0deg)";
              dropdownIcon.style.transition = "transform 0.3s ease";
            }
          }
        }, 100);
      });
    }

    // Handle side-arrow dropdowns within the main dropdown
    var subDropdowns = dropdown.querySelectorAll(".header-sidearrow-show");

    subDropdowns.forEach(function (subDropdown) {
      var parentItem = subDropdown.parentElement;

      parentItem.addEventListener("mouseenter", function () {
        // Show the sub-dropdown content
        subDropdown.style.display = "block";
        subDropdown.style.opacity = "1";
      });

      parentItem.addEventListener("mouseleave", function () {
        // Hide the sub-dropdown content only if the mouse is not over the sub-dropdown
        setTimeout(function () {
          if (!parentItem.matches(":hover") && !subDropdown.matches(":hover")) {
            subDropdown.style.display = "none";
            subDropdown.style.opacity = "0";
          }
        }, 100);
      });

      subDropdown.addEventListener("mouseenter", function () {
        // Keep the sub-dropdown open when hovering over the sub-dropdown content
        subDropdown.style.display = "block";
        subDropdown.style.opacity = "1";
      });

      subDropdown.addEventListener("mouseleave", function () {
        // Hide the sub-dropdown when leaving the sub-dropdown content
        setTimeout(function () {
          if (!parentItem.matches(":hover") && !subDropdown.matches(":hover")) {
            subDropdown.style.display = "none";
            subDropdown.style.opacity = "0";
          }
        }, 100);
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  let lastScrollTop = 0;
  // return;
  const headers = document.querySelectorAll(
    ".header-bar-web, .nav-header-mobile"
  );
  // const headerFestiveBannerCtr = document.querySelector(".header-festive-sale-banner-container");

  gsap.set(headers[0], { autoAlpha: 1, y: 0 }); // Initialize header to be visible
  gsap.set(headers[1], { autoAlpha: 1, y: 0 }); // Initialize header to be visible
  // gsap.set(headerFestiveBannerCtr, {autoAlpha: 0, y: -100});

  window.addEventListener("scroll", function () {
    let currentScrollTop =
      window.pageYOffset || document.documentElement.scrollTop;

    if (currentScrollTop > lastScrollTop) {
      // Scrolling down
      gsap.to(headers[0], { autoAlpha: 0, y: -100, duration: 0.3 });
      gsap.to(headers[1], { autoAlpha: 0, y: -100, duration: 0.3 });
      // gsap.to(headerFestiveBannerCtr, { autoAlpha: 1, y: 0, duration: 0.3, delay: 0.1 });
    } else {
      // Scrolling up
      gsap.to(headers[0], { autoAlpha: 1, y: 0, duration: 0.3, delay: 0.1 });
      gsap.to(headers[1], { autoAlpha: 1, y: 0, duration: 0.3, delay: 0.1 });
      // gsap.to(headerFestiveBannerCtr, { autoAlpha: 0, y: -100, duration: 0.3});
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Mobile or negative scrolling
  });

  // Initialize the header state based on initial scroll position
  if (window.pageYOffset > 0) {
    gsap.set(headers[0], { autoAlpha: 0, y: -100 });
    gsap.set(headers[1], { autoAlpha: 0, y: -100 });
  }
});

//nav-bar mobile
document.addEventListener("click", function (event) {
  const navMenu = document.getElementById("nav-menu");
  const navToggle = document.getElementById("nav-toggle");

  // Check if the click was outside the nav menu and toggle button
  if (!navMenu.contains(event.target) && !navToggle.contains(event.target)) {
    navMenu.style.display = "none";
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("nav-toggle").addEventListener("click", function () {
    const navMenu = document.getElementById("nav-menu");

    // Toggle the display of the nav menu
    if (navMenu.style.display === "none" || navMenu.style.display === "") {
      navMenu.style.display = "block";
    } else {
      navMenu.style.display = "none";
    }
  });
});

// document.addEventListener('DOMContentLoaded', function() {
//     let lastScrollTop = 0;
//     const header = document.querySelector('.header-bar-mobile');

//     // Initialize header to be visible
//     gsap.set(header, { autoAlpha: 1, y: 0 });

//     window.addEventListener('scroll', function() {
//         let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

//         // Debounce logic to limit the frequency of scroll handling
//         if (Math.abs(currentScrollTop - lastScrollTop) > 5) {
//             if (currentScrollTop > lastScrollTop) {
//                 // Scrolling down
//                 gsap.to(header, { autoAlpha: 0, y: -100, duration: 0.3 });
//             } else {
//                 // Scrolling up
//                 gsap.to(header, { autoAlpha: 1, y: 0, duration: 0.3 });
//             }
//             lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
//         }
//     });

//     // Set initial state of the header based on the initial scroll position
//     if (window.pageYOffset > 0) {
//         gsap.set(header, { autoAlpha: 0, y: -100 });
//     }
// });

/** Cart related */
document.addEventListener("DOMContentLoaded", function () {
  // Add click handler for cart button.
  const cartButtons = document.querySelectorAll(".header-cart, .cart-mobile");
  const cartModal = document.querySelector("dialog.cart-container");
  const cartCountBadges = document.querySelectorAll(
    ".header-cart .cart-count-badge, .cart-mobile .cart-count-badge"
  );

  // Whereever "Add to cart" action is performed, we need to emit this event, to keep the badge count updated.
  Shopify.eventBus.on("add-variant-to-cart", (e) => {
    cartCountBadges.forEach((c) => {
      c.classList.remove("hide");
    });

    updateBadgeCount();
  });

  // Handles update events from the Cart Slider.
  Shopify.eventBus.on("update-cart-badge", (quantity) => {
    if (quantity == 0) {
      cartCountBadges.forEach((c) => {
        c.classList.add("hide");
      });
    } else {
      cartCountBadges.forEach((c) => {
        c.classList.remove("hide");
      });
    }
    updateBadgeCountTo(quantity);
  });

  cartButtons.forEach((btn) => {
    btn.addEventListener("click", async () => {
      try {
        if (cartModal && !cartModal.open) {
          cartModal.showModal();
        } else {
          cartModal.close();
        }
      } catch (error) {
        console.error(error);
      }
    });
  });

  function updateBadgeCountTo(quantity) {
    cartCountBadges.forEach((c) => {
      c.textContent = quantity;
    });
  }

  function updateBadgeCount() {
    cartCountBadges.forEach((c) => {
      c.textContent = parseInt(c.textContent) + 1;
    });
  }
});

/** Sales strip */
document.addEventListener("DOMContentLoaded", function () {
  const appearAnimationStayTime = 5000; // 5s.
  const salesStrips = document.querySelectorAll(".sales-strip-content");
  var activeSalesStripIndex = 0;
  const activeSalesStripLength = salesStrips.length;

  if (salesStrips.length == 0) {
    document.querySelector(".sales-strip-container").remove();
  } else {
    salesStrips[activeSalesStripIndex].classList.add("active");

    const timerHandler = setInterval(showSalesStripsInAppear, appearAnimationStayTime);

    function showSalesStripsInAppear() {
      salesStrips[activeSalesStripIndex].classList.remove("active");
      activeSalesStripIndex =
        (activeSalesStripIndex + 1) % activeSalesStripLength;
      salesStrips[activeSalesStripIndex].classList.add("active");
    }
  }
});
